import { Field } from 'react-final-form'
import CheckboxField from '@mui/material/Checkbox'

import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBox from '@mui/icons-material/CheckBox'

type CheckFieldProps = {
  name: string
  id: string
  value: any
  style?: any
  overrideMuiStyle?: any
  onClick?: () => void
}

const CheckField = ({
  name,
  value,
  style,
  id,
  overrideMuiStyle,
  onClick,
}: CheckFieldProps) => {
  return (
    <Field id={id} name={name} component="input" type="checkbox" value={value}>
      {({ input: { value, name, onChange } }) => (
        <CheckboxField
          id={id}
          style={style}
          //   checked={dot.pick(name, values) === value}
          disableRipple
          name={name}
          color="primary"
          value={value}
          onChange={onChange}
          checkedIcon={<CheckBox />}
          icon={<CheckBoxOutlineBlank color="primary" />}
          onClick={() => {
            if (onClick) onClick!()
          }}
          sx={{
            '&.MuiCheckbox-root': {
              paddingTop: 0,
              '&:hover': {
                backgroundColor: 'transparent',
              },
            },
            ...overrideMuiStyle,
          }}
        />
      )}
    </Field>
  )
}

export default CheckField
